/**
 * Utility to extract plain text from HTML content.
 * It tries to find the body part, removes script/style tags, strips other HTML tags,
 * and decodes basic HTML entities.
 */
export function extractTextFromHtml(html: string): string {
  if (!html) return '';

  // 1. Try to extract content within <body> tags
  const bodyMatch = html.match(/<body[^>]*>([\s\S]*)<\/body>/i);
  let content = bodyMatch ? bodyMatch[1] : html;

  // 2. Remove script and style tags and their content
  content = content.replace(/<(script|style)[^>]*>[\s\S]*?<\/\1>/gi, '');

  // 3. Remove all other HTML tags
  content = content.replace(/<[^>]+>/g, ' ');

  // 4. Decode HTML entities (basic ones)
  content = content
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#039;/g, "'");

  // 5. Replace multiple whitespaces with a single one and trim
  return content.replace(/\s+/g, ' ').trim();
}
